import classNames from "classnames";
import React, { ReactNode } from "react";

import { Section } from "styles";

import { Variant } from "./types";

type Props = {
  variant: Variant;
  children?: ReactNode;
  className?: string;
};

const VARIANT_CLASS_NAMES: Record<Variant, string> = {
  full: "grid-cols-1 pb-8",
  cta: "grid-cols-1 md:grid-cols-2 pb-16 pt-4 md:pb-24 md:pt-20 lg:grid-cols-12",
  "left-image": "grid-cols-1 py-8 md:grid-cols-12 xl:py-32 items-center",
  "right-image": "grid-cols-1 py-8 md:grid-cols-12 lg:py-32 items-center",
  thirds: "grid-cols-1 md:grid-cols-2 gap-16 py-28 lg:grid-cols-3",
  "half-half": "grid-cols-1 gap-5 py-12 md:py-28 lg:grid-cols-12",
  "right-image-wide":
    "grid-cols-1 md:grid-cols-12 items-center pb-9 md:pb-36 md:pl-8 md:pt-12 lg:pl-[70px]",
  "large-number": "grid grid-cols-1 py-8 md:grid-cols-12 gap-5",
  "right-image-half-half":
    "grid-cols-1 md:grid-cols-12 items-center pb-9 md:pb-16 md:pt-40 lg:pl-[70px] gap-5",
};

export const PageSection = (props: Props) => {
  const { children, className, variant } = props;
  const sectionClassName = classNames(
    "grid",
    VARIANT_CLASS_NAMES[variant],
    className,
  );

  // For some reason, the order in which styles are applied from tailwind classes
  // and styled components is inconsistent in the project. This is a necessary hack that
  // returns unstyled div instead of Section component, so that we can avoid
  // Section component styles overwriting styles applied by tailwind classes
  if (
    variant === "left-image" ||
    variant === "right-image-wide" ||
    variant === "right-image" ||
    variant === "right-image-half-half"
  ) {
    return (
      <div className={classNames(sectionClassName, "max-md:px-6")}>
        {children}
      </div>
    );
  }

  return <Section className={sectionClassName}>{children}</Section>;
};
